import CollapseCard from '../packages/collapse-card'
import DropdownButton from '../packages/dropdown-button'
import Autocomplete from '../packages/autocomplete'
import Select from '../packages/select'
import FastAdd from '../packages/fast-add'
import Table from '../packages/table'
import FixedBar from '../packages/fixed-bar'
import Space from '../packages/space'
import ExportButton from '../packages/export-button'
import Tooltip from '../packages/tooltip'
import YearRange from '../packages/year-range'
import SearchForm from '../packages/search-form'
import VxeTable from '../packages/vxe-table'
import Status from '../packages/status'
import Container from '../packages/container'
import Input from '../packages/input'
import Progress from '../packages/progress'
import ButtonGroup from '../packages/button-group'
import Item from '../packages/item'
import SelectTree from '../packages/select-tree'
import UploadButton from '../packages/upload-button'
import NotificationContent from '../packages/notification-content'
import DualPaneContainer from '../packages/dual-pane-container'
import FormEditorContainer from '../packages/form-editor-container'
import FormEditorContainerNew from '../packages/form-editor-container-new'
import Amount from '../packages/amount'
import Dialog from '../packages/dialog'

const components = [
  Autocomplete,
  CollapseCard,
  DropdownButton,
  Select,
  FixedBar,
  FastAdd,
  Table,
  Space,
  ExportButton,
  Tooltip,
  YearRange,
  SearchForm,
  VxeTable,
  Status,
  Container,
  Input,
  Progress,
  ButtonGroup,
  Item,
  SelectTree,
  UploadButton,
  DualPaneContainer,
  FormEditorContainer,
  FormEditorContainerNew,
  Amount,
  Dialog,
]

const install = function (Vue, opts = {}) {
  components.forEach((component) => {
    Vue.component(component.name, component)
  })

  Vue.prototype.$MGUI = {
    i18n: {
      t: (key) => key,
    },
    ...opts,
  }

  Vue.prototype.$mgNotify = function (options, callback) {
    const h = this.$createElement ? this.$createElement : new Vue({}).$createElement
    this.$notify({
      ...options,
      message: h(NotificationContent, {
        props: options,
        on: {
          cancel(instance) {
            callback('cancel', instance)
          },
          confirm(instance) {
            callback('confirm', instance)
          },
        },
      }),
    })
  }
  ;['success', 'warning', 'info', 'error'].forEach((type) => {
    Vue.prototype.$mgNotify[type] = function (options, callback) {
      Vue.prototype.$mgNotify({ ...options, type }, callback)
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: '0.0.1',
  install,
  CollapseCard,
  DropdownButton,
  Select,
  Autocomplete,
  FixedBar,
  FastAdd,
  Table,
  Space,
  ExportButton,
  Tooltip,
  YearRange,
  SearchForm,
  VxeTable,
  Status,
  Container,
  Input,
  Progress,
  ButtonGroup,
  Item,
  SelectTree,
  UploadButton,
  DualPaneContainer,
  FormEditorContainer,
  FormEditorContainerNew,
  Dialog,
}
